import { SearchOptionsRequest } from "src/app/shared/models/SearchOptionsRequest.model";

export class HoldingSearchOptions extends SearchOptionsRequest {
  public includeAssets: boolean;
  public includeFunds: boolean;
  public includeApplicationId: boolean;
  public includeFundAssetStatus: boolean;
  public includeDrafts: boolean;

  constructor(pageSize:number = null) {
    super(pageSize);
    this.includeAssets = true;
    this.includeFunds = true;
    this.includeApplicationId = false;
    this.includeFundAssetStatus = false;
    this.includeDrafts = false;
  }
}
